import styled, { css, keyframes } from 'styled-components'

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const COLOR = {
  primary: css`
    color: ${({ theme }) => theme.neutral.text.inverted};
    background: #0769DA;

    :hover {
      background-color: #024ca2;
    }
  `,
  secondary: css`
    color: ${({ theme }) => theme.neutral.text.strong};
    background: transparent;
    border: ${({ theme }) => theme.border.width.thinner}
      ${({ theme }) => theme.border.style.solid}
      ${({ theme }) => theme.neutral.border.strong};

    :hover {
      background-color: ${({ theme }) => theme.neutral.background.weak};
    }
  `,
  tertiary: css`
    color: #0769DA;
    background: transparent;

    & > svg {
      fill: ${({ theme }) => theme.brand.icon.default};
    }
    :hover {
      background-color: #C6E2F9;
    }
  `,
  danger: css`
    color: ${({ theme }) => theme.neutral.text.inverted};
    background: ${({ theme }) => theme.danger.background.default};

    :hover {
      background-color: ${({ theme }) => theme.danger.background.strong};
    }
  `,
  subtle: css`
    color: ${({ theme }) => theme.neutral.text.default};
    background: transparent;

    :hover {
      background-color: ${({ theme }) => theme.neutral.background.weak};
    }
  `,
}

function disabledBorder(
  color: string,
  borderSize: string,
  borderSolid: string,
  borderColor: string,
) {
  if (color === 'tertiary' || color === 'subtle') return 'none'

  return `${borderSize} ${borderSolid} ${borderColor}`
}

function disabledBackgroundBorder(color: string, backgroundColor: string) {
  if (color === 'tertiary' || color === 'subtle') return 'transparent'

  return backgroundColor
}

export const Button = styled.button<{
  $width: string
  $height: number
  $color: string
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km4};
  cursor: pointer;
  font-size: ${({ theme }) => theme.font.size.m3};
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  border: ${({ theme }) => theme.neutral.border.default};

  ${({ $width, $height, $color, theme }) =>
    css`
      width: ${$width ? $width : 'auto'};
      height: ${$height}px;

      ${COLOR[$color]}

      :disabled {
        color: ${theme.neutral.text.weak};
        border: ${disabledBorder(
          $color,
          theme.border.width.thinner,
          theme.border.style.solid,
          theme.neutral.border.default,
        )};
        background-color: ${disabledBackgroundBorder(
          $color,
          theme.neutral.background.weak,
        )};
        cursor: not-allowed;

        :hover {
          background-color: ${disabledBackgroundBorder(
            $color,
            theme.neutral.background.weak,
          )};
        }
      }
    `}

  & > svg {
    animation: ${rotate} 1s linear infinite;
  }
`
